import { render } from "./DBUploadPage.vue?vue&type=template&id=8a28aea0&scoped=true&ts=true"
import script from "./DBUploadPage.vue?vue&type=script&lang=ts"
export * from "./DBUploadPage.vue?vue&type=script&lang=ts"

import "./DBUploadPage.vue?vue&type=style&index=0&id=8a28aea0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a28aea0"]])

export default __exports__